import { Routes, Route } from "react-router";
import SmsSystemMain from './views/main';
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
const SmsSystemView = (props) => {

    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "smss") && <Route path="list" element={<SmsSystemMain />} />}
            </Routes>
        </>
    )
}
export default SmsSystemView